import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import PricingSection from './components/PricingSection';

const siteUrl = import.meta.env.VITE_SITE_URL ?? 'https://example.com';

const productSchema = {
  '@context': 'https://schema.org',
  '@type': 'Product',
  name: 'SEOPower AI SEO Analysis Tool',
  description: 'AI-powered SEO analysis tool that delivers real-time page audits, keyword insights, and prioritized recommendations to improve your search engine rankings.',
  url: `${siteUrl}/purchase`,
  brand: {
    '@type': 'Brand',
    name: 'SEOPower',
  },
  offers: [
    {
      '@type': 'Offer',
      name: 'Single Use',
      priceCurrency: 'USD',
      price: '9.99',
      availability: 'https://schema.org/InStock',
      url: `${siteUrl}/purchase`,
      description: 'One-time single page SEO analysis report with full recommendations.',
    },
    {
      '@type': 'Offer',
      name: 'Dual Use',
      priceCurrency: 'USD',
      price: '18.99',
      availability: 'https://schema.org/InStock',
      url: `${siteUrl}/purchase`,
      description: 'Two SEO reports — ideal for a baseline and a follow-up comparison after implementing improvements.',
    },
    {
      '@type': 'Offer',
      name: 'Quad Use',
      priceCurrency: 'USD',
      price: '34.99',
      availability: 'https://schema.org/InStock',
      url: `${siteUrl}/purchase`,
      description: 'Four SEO analysis reports for thorough ongoing optimization.',
    },
    {
      '@type': 'Offer',
      name: 'Multi Use',
      priceCurrency: 'USD',
      price: '89.99',
      availability: 'https://schema.org/InStock',
      url: `${siteUrl}/purchase`,
      description: 'Ten SEO analysis reports for ongoing optimization and competitive analysis.',
    },
  ],
};

const breadcrumbSchema = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    {
      '@type': 'ListItem',
      position: 1,
      name: 'Home',
      item: siteUrl,
    },
    {
      '@type': 'ListItem',
      position: 2,
      name: 'Pricing',
      item: `${siteUrl}/purchase`,
    },
  ],
};

const PurchasePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <title>SEOPower Pricing - Buy AI SEO Analysis Plans | SEOPower.co</title>
      <meta name="description" content="Choose an SEOPower plan and get instant AI-powered SEO analysis reports. Single, Dual, and Multi-use options available. Boost your search rankings today." />
      <meta name="keywords" content="SEOPower pricing, buy SEO tool, SEO analysis plan, AI SEO report, search engine optimization pricing" />
      <link rel="canonical" href={`${siteUrl}/purchase`} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(productSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }} />
      <Navbar />
      <div className="pt-24">
        <div className="bg-gradient-to-b from-[#ede9fe] to-white py-16">
          <div className="max-w-4xl mx-auto px-6 text-center">
            <h1 className="text-5xl font-bold text-gray-900 mb-4">
              Choose Your SEOPower Plan
            </h1>
            <p className="text-xl text-gray-600">
              We recommend purchasing at least the Dual Use report option. Use the first report as your baseline report, implement recommended improvements, then 30 - 90 days later run a second report to validate improvements and gain new insights.
            </p>
          </div>
        </div>
        <PricingSection />
      </div>
      <Footer />
    </div>
  );
};

export default PurchasePage;
